export const PartnerTier = {
  Gold: 'gold',
  Silver: 'silver',
  Bronze: 'bronze',
  Unmanaged: 'unmanaged',
} as const
export type PartnerTier = typeof PartnerTier[keyof typeof PartnerTier]
